/** @jsxImportSource theme-ui @jsxRuntime classic */
import React from 'react';
import { Flex, Box, Text, Link } from '@tishman/components';

import { formatStoryCategory } from '../utils';

interface StoryFiltersListBlockProps {
  items: readonly string[];
  isMobile?: boolean;
}

const StoryFiltersListBlock = (
  props: StoryFiltersListBlockProps,
): React.JSX.Element | null => {
  const { items, isMobile } = props;

  return (
    <Flex
      data-module="StoryTopics"
      id="storyTopics"
      sx={{
        width: '100%',
        flexDirection: 'column',
        pt: [6, 4],
        pb: 4,
        alignItems: isMobile ? 'center' : 'flex-start',
      }}
    >
      <Text mb={3} variant="storyLeftMenuHeading">
        Topics
      </Text>
      <Flex
        sx={{
          width: '100%',
          flexDirection: isMobile ? 'row' : 'column',
          alignItems: isMobile ? 'center' : 'flex-start',
          justifyContent: 'center',
          flexWrap: isMobile ? 'wrap' : 'nowrap',
        }}
      >
        {items.map((topic) => {
          const formattedTopic = formatStoryCategory(topic);
          return (
            <Box
              key={topic}
              sx={{
                'border': '1px solid',
                'borderColor': isMobile ? 'CREAM' : 'GREEN',
                'padding': '10px',
                'margin': '10px 10px 10px 0',
                'cursor': 'pointer',
                'width': 'fit-content',
                'a div': {
                  color: isMobile ? 'CREAM' : 'GREEN',
                },
                '&:hover': {
                  'backgroundColor': isMobile ? 'CREAM' : 'GREEN',
                  'a div': {
                    color: isMobile ? 'GREEN' : 'CREAM',
                  },
                },
              }}
            >
              <Link
                href={`/magazine/#${formattedTopic}`}
                sx={{
                  'textDecoration': 'none',
                  '&:hover': { textDecoration: 'none' },
                }}
              >
                <Text
                  sx={{
                    variant: 'text.storyTopic',
                    color: isMobile === true ? 'CREAM' : 'GREEN',
                  }}
                >
                  {topic}
                </Text>
              </Link>
            </Box>
          );
        })}
      </Flex>
    </Flex>
  );
};

export default StoryFiltersListBlock;
